/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"

export default function SheetForm({open, close, component, title, description, action}) {
  return (
    <Sheet open={open} onOpenChange={() => close(!open)}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
          <SheetDescription>
            {description}
          </SheetDescription>
        </SheetHeader>
        {component}
        <SheetFooter>
          <SheetClose asChild>
            {/* <Button onClick={action}>Save</Button> */}
          </SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
